export default function CStdioH() {
  return <h2>C Stdio H</h2>;
}
